var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.2 28.8",
    style: {
      enableBackground: "new 0 0 41.2 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2F2E41;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    transform: "translate(-204 -231.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-right",
    transform: "translate(204 231.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_847",
    className: "st0",
    d: "M41.2,26.8c0,1.1-0.9,2-2,2H22.6c-1.1,0-2-0.9-2-2.1c0-1.1,0.9-2,2-2h16.5 C40.3,24.7,41.2,25.7,41.2,26.8L41.2,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_848",
    className: "st0",
    d: "M41.2,14.4c0,1.1-0.9,2.1-2,2.1H2.1c-1.1,0-2.1-0.9-2.1-2c0-1.1,0.9-2.1,2-2.1 c0,0,0,0,0,0h37.1C40.3,12.4,41.2,13.3,41.2,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_849",
    className: "st0",
    d: "M39.1,4.1c1.1,0,2.1-0.9,2.1-2S40.3,0,39.1,0c0,0,0,0,0,0H14.4c-1.1,0-2,0.9-2,2.1 c0,1.1,0.9,2,2,2H39.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.f96aea69d9f48e3a1d69f95c7a3240b2.svg";
export { ForwardRef as ReactComponent };